import { isString } from "lodash-es";

export function blobToBase64(blob: Blob | File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);

    reader.onload = () => {
      if (isString(reader.result)) {
        resolve(reader.result);
      } else {
        reject();
      }
    };
    reader.onerror = (error) => reject(error);
  });
}
